import { render, staticRenderFns } from "./PaymentdetailShipperRetur.vue?vue&type=template&id=600a6d5d"
import script from "./PaymentdetailShipperRetur.vue?vue&type=script&lang=js"
export * from "./PaymentdetailShipperRetur.vue?vue&type=script&lang=js"
import style0 from "./PaymentdetailShipperRetur.vue?vue&type=style&index=0&id=600a6d5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports